import { Check } from 'lucide-react';

const Header = ({ visitDate, startTime, firstName }) => (
  <div className="text-center">
    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-success-50">
      <Check size={24} strokeWidth={3} className="text-success-600" />
    </div>

    <h3 className="mt-3.5 text-lg font-bold text-secondary-900">
      {firstName ? `Thanks, ${firstName} — you're all set!` : "You're all set!"}
    </h3>
    <p className="mt-1.5 text-sm leading-relaxed text-secondary-500">
      We have you down for{' '}
      <span className="font-bold text-secondary-900">
        {visitDate}
        {startTime ? ` at ${startTime}` : ''}
      </span>
      . The practice will confirm shortly and let you know by text and email.
    </p>
  </div>
);

export default Header;
